import React from 'react';
import { MdMenu } from 'react-icons/md';
import { IconButton, ICON_BUTTON_SIZE_LG } from '@aibuild/ui';
import { useSidebar } from '@contexts/useSidebar';
import { Slot } from './MobileMenuButton.styled';

const MobileMenuButton: React.FC = () => {
  const { openMobile } = useSidebar();

  return (
    <Slot>
      <IconButton
        ariaLabel="Open menu"
        icon={<MdMenu size={24} />}
        size={ICON_BUTTON_SIZE_LG}
        onClick={openMobile}
        dataTestId="mobile-menu-button"
      />
    </Slot>
  );
};

export default MobileMenuButton;
